export const Theme = Object.freeze({
  primary: 'blue',
  secondary: '#fff',
  text: 'blue',
  foreground: '#4A2A17',
  background: '#F0F0F0',
  fontFamily: 'Montserrat',
  fontFamilyBold: 'Montserrat',
  fontFamilyMedium: 'Montserrat',
  fontFamilySemiBold: 'Montserrat',
  fontFamilyLight: 'Montserrat',
})
